import {
    IconButton, Label, Stack, Text, TextField
} from "@fluentui/react";
import { ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { textProp } from "global/Application";
import {
    IEntityReferenceValue as FAM_IEntityReferenceValue
} from "model/FlexibleAttributeModel";
import React from "react";
import EntityLink from "./EntityLink";

const lookupRowStyles = { root: { width: '100%', alignItems: 'flex-end' as const } };
const fieldWrapperStyle: React.CSSProperties = { flex: '1 1 auto', minWidth: 0 };
const textFieldStyles: Partial<ITextFieldStyles> = {
    field: { cursor: 'pointer' },
    suffix: { backgroundColor: 'transparent' },
    root: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'block',
        width: '100%',
    }
};
const actionsStyles = { root: { flexShrink: 0 } };
const iconButtonStyles = { root: { height: '100%' } };
const deleteIconProps = { iconName: 'Clear', styles: { root: { fontSize: 'x-small', margin: '4px', padding: '4px' } } };
const lookupIconProps = { iconName: 'Search', styles: { root: { fontSize: 'small', margin: '4px', padding: '4px' } } };
const previewIconProps = { iconName: 'Preview', styles: { root: { fontSize: 'small', padding: '5px' } } };
const noopChange = () => {};


interface IProps {
    label?: string;
    onLookup?: () => void;
    defaultValue?: string;
    value?: string;
    disabled?: boolean;
    // if they can manually type in lookup
    freeForm?: boolean;
    valueEntityReference?: FAM_IEntityReferenceValue;
    fieldValueOnChange?: (event: any, value: FAM_IEntityReferenceValue | null) => void;
    required?: boolean;
    onDelete?: () => void;
    placeHolder?: string;
    description?: string;
    onPreview?: () => void;

}

const LookupControlBase: React.FC<IProps> = (props) => {

    const onLookup = React.useCallback(() => {
        if (!props.disabled)
            props.onLookup?.();
    }, [props.disabled, props.onLookup]);

    const onDelete = React.useCallback(() => {
        if (!props.disabled)
            props.onDelete?.();
    }, [props.disabled, props.onDelete]);

    const onKeyDown = React.useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter")
            onLookup();
    }, [onLookup]);


    return <Stack horizontal styles={lookupRowStyles}>
        <div style={fieldWrapperStyle}>
            <TextField
                required={props.required}
                label={props.label}
                defaultValue={props.value
                    ? undefined
                    : (props.defaultValue ?? "...")
                }
                placeholder={props.placeHolder}
                value={props.value}
                styles={textFieldStyles}
                onClick={onLookup}
                onKeyDown={onKeyDown}
                readOnly={!props.freeForm}
                disabled={props.disabled}
                description={props.description}
                onRenderInput={props.valueEntityReference
                    ? (defaultProps, defaultRender) => {
                        return <div style={{ width: '100%', paddingTop: '6px', paddingLeft: '7px' }} onClick={onLookup}>
                            <EntityLink entity={props.valueEntityReference!} disabled={props.disabled} />
                        </div>;
                    }
                    : undefined
                }
                onChange={noopChange}
            />
        </div>
        {!props.disabled &&
            <Stack horizontal styles={actionsStyles}>
                {props.onDelete &&
                    <IconButton
                        iconProps={deleteIconProps}
                        styles={iconButtonStyles}
                        onClick={onDelete}
                    />
                }
                {props.onLookup &&
                    <IconButton
                        iconProps={lookupIconProps}
                        styles={iconButtonStyles}
                        onClick={onLookup}
                    />
                }
                {props.onPreview &&
                    <IconButton
                        iconProps={previewIconProps}
                        styles={iconButtonStyles}
                        onClick={props.onPreview}
                    />
                }
            </Stack>
        }
    </Stack>
}


export default (LookupControlBase);
